var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 83.9593 211.4965",
    enableBackground: "new 0 0 83.9593 211.4965",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5246,132.2533c0.1182,0,0.2373-0.0029,0.3564-0.0098c3.3076-0.1943,5.833-3.0322,5.6396-6.3408 c-2.0046-34.2599,2.1207-50.831,6.2422-58.8065V116.5v7.1332v78.031c0,5.4318,4.4034,9.8323,9.8322,9.8323 c5.4303,0,9.8339-4.4005,9.8339-9.8323v-70.3026h7.1023v70.3026c0,5.4318,4.4036,9.8323,9.8323,9.8323 c5.4302,0,9.8337-4.4005,9.8337-9.8323v-78.031V116.5V67.0963c4.1208,7.9753,8.2461,24.5464,6.2415,58.8064 c-0.1934,3.3086,2.332,6.1465,5.6396,6.3408c0.1191,0.0068,0.2383,0.0098,0.3564,0.0098c3.1533,0,5.7979-2.4609,5.9844-5.6494 c2.2305-38.1436-2.4531-62.9478-13.9219-73.7231c-4.3896-4.1256-8.6318-5.1251-11.1313-5.3124 c-0.2947-0.0341-0.5933-0.0562-0.8972-0.0562H26.4913c-0.3043,0-0.603,0.0222-0.8981,0.0563 c-2.4993,0.1874-6.7402,1.187-11.1311,5.3123C2.9933,63.6566-1.6903,88.4603,0.5402,126.6039 C0.7277,129.7924,3.3713,132.2533,6.5246,132.2533z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5257 -0.8507 0.8507 0.5257 2.1251 45.6256)",
    cx: 41.9797,
    cy: 20.907,
    rx: 20.907,
    ry: 20.9069
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal-icon.0f0609395b1ae1fcb55a299842fc2978.svg";
export { ForwardRef as ReactComponent };